// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"07763715","400":"370fbd3f","416":"8944683e","531":"6ab56645","813":"b09c7b39","831":"b548bb6c"}[chunkId] + ".chunk.js";
};